import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SwWorkFlowModule } from './sw-work-flow/sw-work-flow.module';
import { BasicComponentsModule } from '../basic-components/basic-components.module';
import { IconSelectComponent } from './sw-icon-select/icon-select.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SwRightClickMenuComponent } from './sw-right-click-menu/sw-right-click-menu.component';
import { SwDynamicFormViewComponent } from './sw-dynamic-form-view/sw-dynamic-form-view.component';
import { SwDynamicFormAddComponent } from './sw-dynamic-form-add/sw-dynamic-form-add.component'
import { SwDynamicFormLinkFormComponent } from './sw-dynamic-form-link-form/sw-dynamic-form-link-form.component';
import { SwDynamicFormLinkUserComponent } from './sw-dynamic-form-link-user/sw-dynamic-form-link-user.component';
import { SwDynamicFormAddTabComponent } from './sw-dynamic-form-add-tab/sw-dynamic-form-add-tab.component';
import { SwDynamicFormViewTabComponent } from './sw-dynamic-form-view-tab/sw-dynamic-form-view-tab.component';
import { SwQuickMenusComponent } from './sw-quick-menus/sw-quick-menus.component';
import { SwQuickMenusBoxComponent } from './sw-quick-menus/sw-quick-menus-box/sw-quick-menus-box.component'
import { SwExportGlobalComponent } from './sw-export-global/sw-export-global.component';
import { SwExportColumnComponent } from './sw-export-column/sw-export-column.component';
import { SwFlowChartComponent } from './sw-flow-chart/sw-flow-chart.component';
import { SwEditdeleteWorkflowComponent } from './sw-editdelete-workflow/sw-editdelete-workflow.component';
import { GlobalSearchService } from '../../serves/public/global-search.service';
import { SwGlobalSearchComponent } from './sw-global-search/sw-global-search.component';
import { SwSonlineComponent } from './sw-sonline/sw-sonline.component';
import { ChartsBasicComponent } from './sw-charts-basic/charts-basic.component';
import { SwGlobalSearchIndexComponent } from './sw-global-search-index/sw-global-search-index.component';
import { SwDynamicFormLinkOrganizeComponent } from './sw-dynamic-form-link-organize/sw-dynamic-form-link-organize.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BasicComponentsModule,
    SwWorkFlowModule,
    FormsModule
  ],
  providers: [DatePipe,GlobalSearchService],
  declarations: [IconSelectComponent, SwRightClickMenuComponent, SwDynamicFormLinkFormComponent,SwDynamicFormLinkUserComponent,SwDynamicFormViewComponent,SwDynamicFormAddComponent,
    SwDynamicFormAddTabComponent,SwDynamicFormViewTabComponent,SwQuickMenusComponent,SwQuickMenusBoxComponent,SwExportGlobalComponent,SwExportColumnComponent, SwFlowChartComponent, 
    SwEditdeleteWorkflowComponent,SwGlobalSearchComponent,SwSonlineComponent,SwGlobalSearchIndexComponent,ChartsBasicComponent,SwDynamicFormLinkOrganizeComponent],
  exports: [SwWorkFlowModule,IconSelectComponent, SwRightClickMenuComponent, SwDynamicFormLinkFormComponent,SwDynamicFormLinkUserComponent,SwDynamicFormViewComponent,SwDynamicFormAddComponent,
    SwDynamicFormAddTabComponent,SwDynamicFormViewTabComponent,SwQuickMenusComponent,SwExportGlobalComponent,SwExportColumnComponent,SwFlowChartComponent,SwEditdeleteWorkflowComponent,SwGlobalSearchComponent,
    SwSonlineComponent,SwGlobalSearchIndexComponent,SwDynamicFormLinkOrganizeComponent],
  entryComponents:[SwDynamicFormLinkFormComponent,SwDynamicFormLinkUserComponent,SwDynamicFormViewComponent,SwDynamicFormAddComponent,SwQuickMenusBoxComponent,SwFlowChartComponent,SwEditdeleteWorkflowComponent,
    ChartsBasicComponent,SwDynamicFormLinkOrganizeComponent,IconSelectComponent]
})
export class AppComponentsModule { }

